/** @class module.undoRedo.PouchAdapter */
/*global PouchDB, emit */
define(
    "diy/undo-redo/PouchAdapter",
    [
        'jquery'
    ],
    function ($) {
        'use strict';
        var PouchAdapter,
            DOC_TYPE_ENTRY = 'entry',
            POUCHDB_OPTIONS = {size: 5},
            designDocs;


        designDocs = {
            'byEntryType': {
                version: 1,
                mapFunction: function (doc) {
                    if (doc.docType === 'entry') {
                        emit(doc.type + '/' + doc._id, {rev: doc._rev});
                    }
                }
            },
            'byUndoSession': {
                version: 1,
                mapFunction: function (doc) {
                    var formatIndex = function (n, width, z) {
                        z = z || '0';
                        width = width || 5;
                        n = n.toString() + '';
                        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
                    };

                    if (doc.docType === 'entry') {
                        emit(
                            doc.undoSessionId + '_' + formatIndex(doc.undoSessionIndex) + '/' + doc.type + '/' + doc._id,
                            {rev: doc._rev}
                        );
                    }
                }
            },
            'bySessionSorted': {
                version: 2,
                mapFunction: function (doc) {
                    var formatIndex = function (n, width, z) {
                        z = z || '0';
                        width = width || 5;
                        n = n.toString() + '';
                        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
                    };

                    if (doc.docType === 'entry') {
                        emit(
                            [
                                doc.type,
                                doc.websiteId,
                                doc.sessionId,
                                doc.undoSessionId,
                                formatIndex(doc.undoSessionIndex)
                            ],
                            {rev: doc._rev}
                        );
                    }
                }
            }

        };

        PouchAdapter = Klazz.extend(/** @lends module.undoRedo.PouchAdapter.prototype */{

            database: {},
            databaseName: null,
            databasePromise: null,
            autoIncrementKey: null,
            websiteId: null,
            sessionId: null,

            keyIndex: {},

            enabledIndexes: {},

            staticPrefix: '-static-',

            /**
             * @constructs
             * @param databaseName
             */
            initialize: function (databaseName) {
                this.databaseName = databaseName;
            },
            init: function (websiteId, sessionId) {
                this.websiteId = websiteId;
                this.sessionId = sessionId;
            },
            createPersistentDatabase: function () {
                var database, deferred;
                deferred = Q.defer();
                database = new PouchDB(this.databaseName, POUCHDB_OPTIONS);
                if (database.adapter) {
                    return database
                        .then(function () {
                            return this.enableIndexes(['byEntryType', 'byUndoSession', 'bySessionSorted'], database)
                                .then(function () {
                                   return database;
                                });
                        }.bind(this));
                } else {
                    deferred.reject({status: 500, 'message': 'Undefined PouchDB adapter'});
                }

                return deferred.promise;
            },
            cleanup: function cleanup() {
                var database, deferred;
                deferred = Q.defer();
                try {
                    database = new PouchDB(this.databaseName, POUCHDB_OPTIONS);
                    database.allDocs({}, function (err, res) {
                        var toDelete = [];
                        if (err) {
                            deferred.reject(err);
                        } else {
                            res.rows.forEach(function (row) {
                                toDelete.push({_id: row.id, _rev: row.value.rev, _deleted: true});
                            });
                            if (toDelete.length) {
                                database.bulkDocs(toDelete, function (deleteErr, deleteRes) {
                                    if (err) {
                                        deferred.reject(deleteErr);
                                    } else {
                                        deferred.resolve(deleteRes);
                                    }
                                });
                            } else {
                                deferred.resolve(true);
                            }
                        }
                    });
                } catch (error) {
                    deferred.reject(error);
                }
                return deferred.promise;
            },
            open: function () {
                var deferred;
                deferred = Q.defer();
                this.openDatabase()
                    .then(function () {
                        deferred.resolve(this);
                    }.bind(this))
                    .catch(function (error) {
                        deferred.reject(error);
                    });

                return deferred.promise;
            },
            openDatabase: function () {
                var deferred;
                deferred = Q.defer();
                this.createPersistentDatabase()
                    .then(function (database) {
                        this.database = database;
                        deferred.resolve(database);
                    }.bind(this))
                    .catch(function (error) {
                        this.database = null;
                        deferred.reject(error);
                    }.bind(this));

                return deferred.promise;
            },
            getDatabase: function () {
                return this.database;
            },

            createEntryKey: function (createdTime) {
                // key format entry_[websiteId]_[sessionId]_[createdTime]_uniqueIndex
                if (createdTime === undefined) {
                    createdTime = (new Date()).getTime();
                }
                if (this.keyIndex[createdTime] === undefined) {
                    this.keyIndex[createdTime] = 1;
                } else {
                    this.keyIndex[createdTime]++;
                }

                return ['entry', this.websiteId, this.sessionId, createdTime, this.keyIndex[createdTime]].join('_');
            },

            createDesignDoc: function (name, mapFunction, version) {
                var ddoc = {
                    _id: '_design/' + name,
                    ver: version,
                    views: {}
                };
                ddoc.views[name] = {
                    map: mapFunction.toString()
                };
                return ddoc;
            },

            /**
             *
             * @param {Array.<String>} indexNames
             * @param {*} database
             * @returns {*}
             */
            enableIndexes: function enableIndexes(indexNames, database) {
                var deferred = Q.defer(), toEnable = [];
                indexNames.forEach(function (name) {
                    toEnable.push(function () {
                        return this.enableIndex(name, database);
                    }.bind(this));
                }.bind(this));

                toEnable.reduce(Q.when, Q(true))
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            enableIndex: function (indexName, database) {
                var designDoc, deferred = Q.defer();

                designDoc = this.createDesignDoc(
                    indexName, designDocs[indexName].mapFunction, designDocs[indexName].version
                );

                database.get(designDoc._id, function (err, res) {
                    if (res) {
                        // index already in db, checking version
                        if (res.ver === designDoc.ver) {
                            deferred.resolve(true);
                            return;
                        } else {
                            designDoc._rev = res._rev;
                        }
                    }
                    database.put(designDoc, function (err, res) {
                        if (err) {
                            deferred.reject(err);
                        } else {
                            deferred.resolve(res);
                        }
                    });
                });

                return deferred.promise;
            },

            // add entry to database
            add: function (data, id) {
                var
                    deferred = Q.defer(),
                    doc = data,
                    createdTime = (new Date()).getTime();

                if (typeof id === 'undefined') {
                    id = this.createEntryKey(createdTime);
                }

                doc.docType = DOC_TYPE_ENTRY;
                doc.createdAt = createdTime;
                doc.websiteId = this.websiteId;
                doc.sessionId = this.sessionId;

                this.getDatabase().put(doc, id, function (err, res) {
                    if (err) {
                        deferred.reject(err);
                    } else {
                        deferred.resolve(res.id);
                    }
                });

                return deferred.promise;
            },

            // loads document from database
            load: function (docId) {
                var deferred = Q.defer();
                this.getDatabase().get(docId, function (err, doc) {
                    if (err) {
                        deferred.reject(err);
                    } else {
                        deferred.resolve(doc);
                    }
                });
                return deferred.promise;
            },

            update: function (docId, data) {
                var deferred = Q.defer();

                this.load(docId)
                    .then(function (previousDocument) {
                        data = $.extend({}, previousDocument, data);

                        this.getDatabase().put(data, previousDocument._id, previousDocument._rev, function (err, res) {
                            if (err) {
                                deferred.reject(err);
                            } else {
                                deferred.resolve(res);
                            }
                        });
                    }.bind(this))
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },

            loadHistory: function () {
                var
                    deferred = Q.defer(),
                    history = {
                        undoList: [],
                        redoList: []
                    };
                this.openDatabase()
                    .then(function (database) {
                        this.loadUndoList(database)
                            .then(function (rows) {
                                history.undoList = rows;
                                return this.loadRedoList(database);
                            }.bind(this))
                            .then(function (rows) {
                                history.redoList = rows;
                                deferred.resolve(history);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }.bind(this))
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;
            },
            loadUndoList: function (database) {
                var
                    deferred = Q.defer(),
                    options = {
                        'startkey': ['undo', this.websiteId, this.sessionId],
                        'endkey': ['undo', this.websiteId, this.sessionId, {}],
                        'include_docs': true
                    };
                database.query('bySessionSorted', options)
                    .then(function (res) {
                        var index, response = [];
                        for (index = res.rows.length - 1; index >= 0; index--) {
                            response[index] = res.rows[index].doc;
                        }
                        deferred.resolve(response);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;

            },
            loadRedoList: function (database) {
                var
                    deferred = Q.defer(),
                    options = {
                        'startkey': ['redo', this.websiteId, this.sessionId],
                        'endkey': ['redo', this.websiteId, this.sessionId, {}],
                        'include_docs': true
                    };

                database.query('bySessionSorted', options)
                    .then(function (res) {
                        var index, response = [];

                        for (index = 0; index < res.rows.length; index++) {
                            response[index] = res.rows[index].doc;
                        }
                        deferred.resolve(response);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });
                return deferred.promise;
            },

            deleteRedoEntries: function () {
                var
                    deferred = Q.defer(),
                    options = {
                        'startkey': ['redo'],
                        'endkey': ['redo', {}],
                        'include_docs': true
                    };

                this.getDatabase().query('bySessionSorted', options)
                    .then(function (res) {
                        return this._delete(res);
                    }.bind(this))
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            deleteEntriesFromSession: function deleteEntriesFromSession(sessionId) {
                var
                    deferred = Q.defer(),
                    filter = sessionId,
                    options = {
                        'startKey': filter,
                        'endKey': filter + '_'
                    };
                this.getDatabase().query('byUndoSession', options)
                    .then(this._delete.bind(this))
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (err) {
                        deferred.reject(err);
                    });

                return deferred.promise;
            },
            deleteEntryIds: function (entryIds) {
                var deferred = Q.defer();

                this.getDatabase().allDocs({keys: entryIds}, function (err, res) {
                    if (err) {
                        deferred.reject(res);
                    } else {
                        this._delete(res)
                            .then(function (res) {
                                deferred.resolve(res);
                            })
                            .catch(function (err) {
                                deferred.reject(err);
                            });
                    }
                }.bind(this));

                return deferred.promise;
            },

            _delete: function (res) {
                var
                    deferred = Q.defer(),
                    index,
                    rows = res.rows,
                    totalRows,
                    removeItems = [];

                if (rows) {
                    totalRows = rows.length;

                    if (totalRows > 0) {
                        for (index = 0; index < totalRows; index++) {
                            removeItems[index] = {
                                _id: rows[index].id,
                                _rev: rows[index].value.rev,
                                _deleted: true
                            };
                        }
                        this.getDatabase().bulkDocs(removeItems, function (err, doc) {
                            if (err) {
                                deferred.reject(err);
                            } else {
                                deferred.resolve(doc);
                            }
                        });
                    } else {
                        deferred.resolve(true);
                    }
                } else {
                    deferred.reject('rows undefined');
                }
                return deferred.promise;
            },

            clearAllEntries: function () {
                var
                    deferred = Q.defer(),
                    self = this;

                this.getDatabase().allDocs({'startkey': 'entry'})
                    .then(function (res) {
                        return self._delete(res);
                    })
                    .then(function (res) {
                        deferred.resolve(res);
                    })
                    .catch(function (error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            },

            getStatic: function (docId) {
                var deferred = Q.defer();

                this.getDatabase().get(docId, function (err, res) {
                    if (res) {
                        deferred.resolve(res.data);
                    } else {
                        deferred.resolve(null);
                    }
                }.bind(this));

                return deferred.promise;
            },

            setStatic: function (docId, data, reserved, deferred, tryNumber) {
                if (typeof deferred === 'undefined') {
                    deferred = Q.defer();
                }

                tryNumber = tryNumber || 0;
                var database = this.getDatabase();
                database.get(docId, function (err, doc) {
                    if (err) {
                        if (err.status === 404) {
                            // if not found, just add it
                            database.put({data: data}, docId, function (err, res) {
                                if (err) {
                                    deferred.reject(err);
                                } else {
                                    deferred.resolve(res.id);
                                }
                            });
                        } else {
                            deferred.reject(err);
                        }
                    } else {
                        // if found, update it
                        database.put({data: data}, doc._id, doc._rev, function (err, res) {
                            if (err) {
                                if (err.status === 409) {
                                    if (tryNumber === 3) {
                                        deferred.reject(err);
                                    }
                                    this.setStatic(docId, data, reserved, deferred, ++tryNumber);
                                } else {
                                    deferred.reject(err);
                                }
                            } else {
                                deferred.resolve(res);
                            }
                        }.bind(this));
                    }
                }.bind(this));

                return deferred.promise;
            }
        });

        return PouchAdapter;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/PouchAdapter.js
 ** module id = 908
 ** module chunks = 0
 **/